import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission, VenueType } from '../../generated/graphql';
import { CashFlowIcon } from '../../ui-kit';
import CashFlowView from './CashFlowView';

const CashFlow: RouteType= {
    exact: false,
    path: routePaths.cashFlow,
    title: translate('Cash Flow'),
    icon: CashFlowIcon,
    component: CashFlowView,
    allowedVenueTypes: [VenueType.Restaurant],
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    }
};

export default CashFlow;
